import React from "react"

const LightBlueCircleWithText = props => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div
        style={{
          flex: "0 0 auto",
          width: "9px",
          height: "9px",
          borderRadius: "50%",
          backgroundColor: "#1E93D1",
          ...props.style,
        }}
      />
      <div
        style={{
          flex: "1 1 auto",
          borderBottom: "3px solid #1E93D1",
          position: "relative",
        }}
      >
        {/* <div
          style={{
            position: "absolute",
            top: "-20px",
            textAlign: "right",
            width: "100%",
            right: "20px",
          }}
        >
          some header text
        </div> */}
      </div>
    </div>
  )
}

export default LightBlueCircleWithText
